import { RecalProposalSetDtlEntity } from "./RecalProposalSetDtlEntity"

export interface RecalProposalSetEntity {
    id: number,
    proposalSetName?: string | null,
    proposalSetDesc?: string | null,
    recalProposalSetDtlList?: RecalProposalSetDtlEntity[] | null,

    [key: string]: string | boolean | null | Object | undefined
}

export const EMPTY_RECAL_PROPOSAL_SET_ENTITY: RecalProposalSetEntity = {

    id: 0,
    proposalSetName: null,
    proposalSetDesc: "",
    recalProposalSetDtlList: null,
}